<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-grid">
        <div class="brand-column reveal">
          <div class="logo-wrapper">
            <img
              src="../assets/images/Bizz.png"
              alt="Bizzento"
              class="footer-logo"
            />
          </div>
          <h2 class="footer-manifesto">
            "You decide. <br />
            Bizzento executes and advises."
          </h2>
          <div class="brand-meta">
            <p class="tagline">
              Empowering entrepreneurs with intelligent business automation.
            </p>
          </div>
        </div>

        <div class="links-column">
          <div class="footer-section reveal delay-1">
            <h3 class="section-label">Meet the Founders</h3>
            <div class="founders-stack">
              <div class="founder-card">
                <div class="initials-circle">SR</div>
                <div class="details">
                  <a href="#" class="name">Shruthi R Rao</a>
                  <span class="role">Strategy & Product</span>
                </div>
              </div>
              <div class="founder-card">
                <div class="initials-circle">VS</div>
                <div class="details">
                  <a href="#" class="name">Vipandeep Singh</a>
                  <span class="role">Tech & Intelligence</span>
                </div>
              </div>
            </div>
          </div>

          <div class="footer-section reveal delay-2">
            <h3 class="section-label">Inquiries</h3>
            <a href="mailto:contact@bizzento.com" class="contact-email">
              contact@bizzento.com
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="arrow-icon"
              >
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-wrapper">
      <p class="copyright">© 2026 Bizzento Inc. — All rights reserved.</p>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  --bg-primary: #f2eee0;
  --text-main: #1a1a1a;
  --text-sub: #4a3728;
  --accent-gold: #bfa14d;

  background-color: var(--bg-primary);
  padding: 120px 40px 60px;
  color: var(--text-main);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.footer-container {
  max-width: 1300px;
  margin: 0 auto;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr; 
  gap: 100px;
  align-items: start;
}

.footer-logo {
  width: 320px;
  height: auto;
  max-height: 180px;
  object-fit: contain;
  display: block;
  margin-left: 0;

  transition: transform 0.3s ease;
}
.logo-wrapper {
  display: inline-block;
}

.footer-manifesto {
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.03em;
  margin-bottom: 60px;
  font-style: italic;
}

.tagline {
  font-size: 1.1rem;
  opacity: 0.8;
  margin-bottom: 12px;
}

.copyright {
  font-size: 0.85rem;
  opacity: 0.4;
  font-weight: 600;
}
.copyright-wrapper {
  margin-top: 30px;
}

/* Links Column */
.section-label {
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  margin-bottom: 32px;
  display: block;
  border-bottom: 1.5px solid var(--text-main);
  padding-bottom: 8px;
  width: fit-content;
}

.founders-stack {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 80px;
}

.founder-card {
  display: flex;
  align-items: center;
  gap: 20px;
}

.initials-circle {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  border: 1px solid var(--accent-gold);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.95rem;
}

.name {
  font-weight: 800;
  font-size: 1.1rem;
  text-decoration: none;
  color: var(--text-main);
  display: block;
}

.role {
  font-size: 0.85rem;
  opacity: 0.6;
}

.contact-email {
  font-size: 1.5rem;
  font-weight: 700;
  text-decoration: none;
  color: var(--text-main);
  display: flex;
  align-items: center;
  gap: 12px;
  transition: gap 0.3s ease;
}

.contact-email:hover {
  gap: 20px;
}

@media (max-width: 992px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 80px;
  }
}
@media (max-width: 480px) {
  .footer-logo {
    width: 240px;
    max-height: 140px;
  }
}
</style>
